import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import Rollbar from "rollbar";
import VLibras from "@vue-a11y/vlibras";

const app = createApp(App);

app.config.productionTip = false;

// Registrar Rollbar como propriedade global
app.config.globalProperties.$rollbar = new Rollbar({
  accessToken: "0b8b9a72269f446599592f39c04e4671",
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: "production",
  },
});

// Configurar handler global de erros
app.config.errorHandler = (err, instance, info) => {
  instance.$rollbar.error(err);
  throw err;
};

// Registrar router e store
app.use(router);
app.use(store);
app.use(VLibras);

// Montar a aplicação
app.mount("#app");
